import type { ProjectImageSearchCommand, ProjectImageSearchResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class SearchProjectImagesUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectImageSearchCommand): Promise<ProjectImageSearchResponse> {
    return this.repository.searchProjectImages(command);
  }
}
